import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CommonModule } from "@angular/common";
@Component({
  standalone: true,
  selector: "app-page-not-found",
  templateUrl: "./page-not-found.component.html",
  styleUrls: ["./page-not-found.component.css"],
  imports: [CommonModule],
})
export class PageNotFoundComponent implements OnInit {
  error: string;

  constructor(private router: Router) {}

  ngOnInit() {}

  gotoHome() {
    this.router.navigate(["/"]);
  }
}
